// extracted by mini-css-extract-plugin
module.exports = {"chartLegendRoot":"UydKJUsG","legendItem":"j6EF7SzU","legendIcon":"u_HUmMr8","legendLabel":"PRyTaHGA","miniBar":"noUQYFoA","miniCircle":"_hwE_Qyg"};